export default __webpack_public_path__ + "static/media/cut.ebd9096a.svg";